import React, { useState } from "react";
import DatePicker from "react-modern-calendar-datepicker";

export default function DateForm(props) {
    const startDate = {year: props.startDate.getFullYear(), month: (props.startDate.getMonth() + 1), day: props.startDate.getDate()};
    // console.log(startDate)
    // console.log(utils().getToday());
    const [selectedDay, setSelectedDay] = useState(startDate);
    let setDate = props.setDate;
    // const {register} = useForm();

    const renderCustomInput = ({ ref }) => (
      <input
        readOnly
        ref={ref} // necessary
        placeholder="Pick a date"
        value={selectedDay ? `${selectedDay.day}/${selectedDay.month}/${selectedDay.year}` : ''}
        style={{
          textAlign: 'center',
          fontSize: '1rem',
          border: '1px solid #ced4da',
          padding: '.375rem 0rem .375rem 0rem',
          borderRadius: '5px',
          // boxShadow: '0 .5rem 1rem rgba(0, 0, 0, 0.2)',
          color: '#000000',
          outline: 'none',
          width: '100%'
        }}
        className="my-custom-input-class" // a styling class
      />
    )

    const handleChange = (date) => {
        console.log(date)
        setSelectedDay(date)
        setDate(date);
    };

      return (
        <DatePicker 
          renderInput={renderCustomInput} 
          value={selectedDay}
          onChange={handleChange}
          inputPlaceholder="Select a day"
          minimumDate={startDate}
        />
      );

  }
  
